"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTherapistLower = exports.isTherapist = exports.isSuperAdmin = exports.isPhysicianLower = exports.isPhysician = exports.isPatient = exports.isClinician = exports.isAllowedForRoles = exports.isAdmin = exports.getRoleNameLower = exports.getRoleName = exports.getRoleByRoleName = exports.getClinicianRoles = exports.getAppointmentTypeForRole = exports.getAdminRoles = exports.UserRolesText = exports.UserRoles = exports.AppointmentTypeForRole = void 0;
var _lodash = require("lodash");
var _UserRolesText, _AppointmentTypeForRo;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UserRoles = /*#__PURE__*/function (UserRoles) {
  UserRoles[UserRoles["None"] = 0] = "None";
  UserRoles[UserRoles["Patient"] = 1] = "Patient";
  UserRoles[UserRoles["Doctor"] = 2] = "Doctor";
  UserRoles[UserRoles["Therapist"] = 4] = "Therapist";
  UserRoles[UserRoles["Admin"] = 8] = "Admin";
  UserRoles[UserRoles["SuperAdmin"] = 16] = "SuperAdmin";
  return UserRoles;
}({});
exports.UserRoles = UserRoles;
var getRoles = function getRoles(roles) {
  var entries = (0, _lodash.toPairs)(UserRoles);
  return entries.filter(function (e) {
    return roles.includes(e[1]);
  }).map(function (e) {
    return {
      value: e[1],
      text: e[0]
    };
  });
};
var getAdminRoles = function getAdminRoles() {
  return getRoles([UserRoles.Admin, UserRoles.SuperAdmin]);
};
exports.getAdminRoles = getAdminRoles;
var getClinicianRoles = function getClinicianRoles() {
  return getRoles([UserRoles.Doctor, UserRoles.Therapist]);
};
exports.getClinicianRoles = getClinicianRoles;
var getRoleName = function getRoleName(id) {
  return UserRolesText[id];
};
exports.getRoleName = getRoleName;
var getRoleNameLower = function getRoleNameLower(id) {
  return (0, _lodash.toLower)(getRoleName(id));
};
exports.getRoleNameLower = getRoleNameLower;
var isTherapistLower = function isTherapistLower(roleStr) {
  return roleStr === getRoleNameLower(UserRoles.Therapist);
};
exports.isTherapistLower = isTherapistLower;
var isPhysicianLower = function isPhysicianLower(roleStr) {
  return roleStr === getRoleNameLower(UserRoles.Doctor);
};
exports.isPhysicianLower = isPhysicianLower;
var getRoleByRoleName = function getRoleByRoleName(rolename) {
  return UserRoles[(0, _lodash.capitalize)(rolename)];
};
exports.getRoleByRoleName = getRoleByRoleName;
var getAppointmentTypeForRole = function getAppointmentTypeForRole(role) {
  return AppointmentTypeForRole[role];
};
exports.getAppointmentTypeForRole = getAppointmentTypeForRole;
var UserRolesText = (_UserRolesText = {}, _defineProperty(_UserRolesText, UserRoles.Patient, 'Member'), _defineProperty(_UserRolesText, UserRoles.Doctor, 'Doctor'), _defineProperty(_UserRolesText, UserRoles.Therapist, 'Therapist'), _defineProperty(_UserRolesText, UserRoles.Admin, 'Admin'), _defineProperty(_UserRolesText, UserRoles.SuperAdmin, 'Super Admin'), _UserRolesText);
exports.UserRolesText = UserRolesText;
var AppointmentTypeForRole = (_AppointmentTypeForRo = {}, _defineProperty(_AppointmentTypeForRo, UserRoles.Doctor, 'Physician'), _defineProperty(_AppointmentTypeForRo, UserRoles.Therapist, 'Therapy'), _AppointmentTypeForRo);
exports.AppointmentTypeForRole = AppointmentTypeForRole;
var isAllowedForRoles = function isAllowedForRoles(user) {
  var allowedRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!user) {
    return false;
  }
  var role = user.roles || user.role;
  return !!(role & (0, _lodash.sum)(allowedRoles));
};
exports.isAllowedForRoles = isAllowedForRoles;
var isPatient = function isPatient(user) {
  return isAllowedForRoles(user, [UserRoles.Patient]);
};
exports.isPatient = isPatient;
var isPhysician = function isPhysician(user) {
  return isAllowedForRoles(user, [UserRoles.Doctor]);
};
exports.isPhysician = isPhysician;
var isTherapist = function isTherapist(user) {
  return isAllowedForRoles(user, [UserRoles.Therapist]);
};
exports.isTherapist = isTherapist;
var isClinician = function isClinician(user) {
  return isAllowedForRoles(user, [UserRoles.Doctor, UserRoles.Therapist]);
};
exports.isClinician = isClinician;
var isAdmin = function isAdmin(user) {
  return isAllowedForRoles(user, [UserRoles.Admin, UserRoles.SuperAdmin]);
};
exports.isAdmin = isAdmin;
var isSuperAdmin = function isSuperAdmin(user) {
  return isAllowedForRoles(user, [UserRoles.SuperAdmin]);
};
exports.isSuperAdmin = isSuperAdmin;